<template>
  <div class="page_staging">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>工作台</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs" v-if="isOpen">
        <div class="flex">
          <div class="stagingBox" v-loading="loading">
            <div class="flex tabbox">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="'待审批（' + Todolist_EmpWorks + '）'" name="1"></el-tab-pane>
                <el-tab-pane label="已审批" name="2"></el-tab-pane>
                <el-tab-pane label="我发起的" name="3"></el-tab-pane>
              </el-tabs>
              <el-input v-model="listQuery.key" placeholder="搜索" prefix-icon="el-icon-search" size="small" style="width: 200px;" clearable @blur="searchHandle"></el-input>
            </div>
            <div class="approveBox" v-if="remainData.length > 0">
              <div class="approveItem cp" v-for="(item, index) in remainData" :key="index" @click="toHandel(item)">
                <span class="approveTitle warning" v-if="activeName=='1'">审批</span>
                <span class="approveTitle success" v-if="activeName=='2'">已审批</span>
                <span :class="item.FK_Flow=='1' ? 'approveTitle success' : 'approveTitle warning'" v-if="activeName=='3'">{{item.FK_Flow=='1' ? '已审批' : '审批'}}</span>
                <span>{{ item.Title }}</span>
                <span v-if="activeName=='1'">的流程待审批，请及时处理</span>
              </div>
              <div class="block">
                <el-pagination v-if="totalcount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" layout="total,prev,pager, next" :total="totalcount"></el-pagination>
              </div>
            </div>
            <div v-else>
              <el-empty description="暂无待办事项"></el-empty>
            </div>
          </div>

          <!-- 数据面板 -->
          <div class="shortcuts">
            <el-tabs v-model="activeName2" @tab-click="handleClickShortcuts">
              <el-tab-pane label="客服数据" name="1" v-if="roleName != undefined && (roleName.indexOf('客服') > -1 || roleName.indexOf('管理员') > -1)">
                <div class="dataBoard">
                  <div class="dataItem cp" v-for="(item, index) in list3" :key="index" @click="toSignupList">
                    <div class="dataNum">{{ numList[item.num] ? numList[item.num] : 0 }}</div>
                    <div class="dataTitle">{{ item.title }}</div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="招聘数据" name="2" v-if="roleName != undefined && (roleName.indexOf('招聘') > -1 || roleName.indexOf('管理员') > -1)">
                <div class="dataBoard">
                  <div class="dataItem cp" v-for="(item, index) in list" :key="index" @click="toSignupList">
                    <div class="dataNum">{{ numList[item.num] ? numList[item.num] : 0 }}</div>
                    <div class="dataTitle">{{ item.title }}</div>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="业务数据" name="3" v-if="roleName != undefined && (roleName.indexOf('业务') > -1 || roleName.indexOf('管理员') > -1)">
                <div class="dataBoard">
                  <div class="dataItem cp" v-for="(item, index) in list" :key="index" @click="toSignupList">
                    <div class="dataNum">{{ numList[item.num] ? numList[item.num] : 0 }}</div>
                    <div class="dataTitle">{{ item.title }}</div>
                  </div>
                </div>
              </el-tab-pane>

              <el-tab-pane label="统计数据" name="4" v-if="roleName != undefined && (roleName.indexOf('客服') == -1 && roleName.indexOf('管理员') == -1 && roleName.indexOf('业务') == -1 && roleName.indexOf('招聘') == -1)">
                <div class="dataBoard">
                  <div class="dataItem cp" v-for="(item, index) in list3" :key="index" @click="toSignupList">
                    <div class="dataNum">{{ numList[item.num] }}</div>
                    <div class="dataTitle">{{ item.title }}</div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>

        <div class="flex" style="margin-top: 20px;">
          <div class="stagingBox">
            <div class="flex tabbox">

              <!-- 消息通知 -->
              <div class="messageTitle">消息通知</div>
              <el-input v-model="listQuery.name" placeholder="搜索" size="small" style="width: 200px;" clearable></el-input>
            </div>
            <!-- <div class="approveBox">
              <div class="approveItem cp" v-for="(item, index) in 8" :key="index">
                《XXXX项目》【发薪】已完成，应发12人，实发10人，请知悉。 2023/12/23 09:03:02
              </div>
            </div> -->
            <div>
              <el-empty description="暂无消息通知"></el-empty>
            </div>
          </div>
          <div class="shortcuts">
            <div class="messageTitle">快捷入口</div>
            <div class="dataBoard">
              <div class="dataItem cp" v-for="(item, index) in shortcutList" :key="index" @click="goto(item.path)">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">{{ item.name }}</div>
              </div>
              <div class="dataItem cp" @click="gotoOut()" v-if="checkPermission(['table_Data_driver1'], permissionLists)">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">数据驾驶舱</div>
              </div>
              <div class="dataItem cp" @click="goto('/tePaymentList')" v-if="isTest">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">暂支</div>
              </div>
              <div class="dataItem cp" @click="goto('/workLog')" v-if="isTest">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">工作日志</div>
              </div>
              <div class="dataItem cp" @click="goto('/finSet')" v-if="roleName.indexOf('管理员') > -1">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">财务设置</div>
              </div>
              <div class="dataItem cp" @click="gotoOut2()">
                <div class="iconBox">
                  <i class="el-icon-menu"></i>
                </div>
                <div class="dataTitle">业务-客户管理</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else style="background: #fff;">
        <el-empty description="暂未开放"></el-empty>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          key: '',
          type: '1',
          pageNum: 1,
          pageSize: 10,
        },
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        Num: 6,
        activeName: '1',
        activeName2: '1',
        loading: false,
        Todolist_EmpWorks: 0, //待审批数量
        remainData: [], //待办列表
        list: this.$store.state.EMP.list,
        list3: this.$store.state.EMP.list3,
        permissionLists: [],
        roleName: '',
        isOpen: true,
        numList: {
          beempcont: 0,
          entrymouthcont: 0,
          interttodaycont: 0,
          interttorrcont: 0,
          pendingcont: 0,
          quitcont: 0,
          facetodaycont: 0,
          entrycont: 0,
          beworkcont: 0,
          quitmouthcont: 0,
          entryweekcont: 0,
          quitweekcont: 0
        }, //工作台数据
        workLoading: false,
        shortcutList: [],
        isTest: false,
        needLoading: false,
      }
    },
    created() {
      this.getOAHomeInit();
      this.getOATodolist();
      this.getJbUserDetail();
      this.getShortcutList();
      this.isTest = location.origin.indexOf('localhost') > -1 || location.origin.indexOf('dev') > -1;
      this.getButtonPower();
    },
    mounted() {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && this.needLoading) {
          this.needLoading = false;
          this.getOAHomeInit();
          this.getOATodolist();
        } else {}
      })
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        let butQuery = {
          path: '/staging',
          powerEnName: 'staging'
        }
        xz.getbtnPowerIdBypage(butQuery).then(res => {
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                that.permissionLists.push(element.Enname);
              }
              // console.log(that.permissionLists)
            } else {
              this.permissionLists = []
            }
          } else {
            this.$message.error('获取按钮权限出错')
            this.permissionLists = []
          }
        })
      },
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取用户详情
      getJbUserDetail() {
        let data = {
          mainuserid: "",
          useridr: Cookies.get("userid-b"),
        }
        xz.getauthJbUserDetailNew(Cookies.get("userid-b"), data).then(res => {
          if (res.status == 'ok') {
            this.roleName = res.msg.StationName;
            this.judgePower();
          } else {
            this.$message.error('系统出错')
            this.roleName = ''
          }
        })
      },
      judgePower() {
        if (this.roleName.indexOf('客服') > -1 || this.roleName.indexOf('管理员') > -1) {
          this.activeName2 = '1';
          this.getNum(1);
        } else if (this.roleName.indexOf('招聘') > -1) {
          this.activeName2 = '2';
          this.getNum(2);
        } else if (this.roleName.indexOf('业务') > -1) {
          this.activeName2 = '3';
          this.getNum(3);
        } else {
          this.activeName2 = '4';
          this.getNum(4);
        }
      },
      handleClickShortcuts(tab) {
        // let a = this.roleName.indexOf('管理员') > -1;
        // if (this.activeName2 == '0') {
        //   let strtype = a ? '管理员客服' : '客服';
        //   this.getNum(strtype);
        // } else if (this.activeName2 == '1') {
        //   let strtype = a ? '管理员招聘' : '招聘';
        //   this.getNum(strtype);
        // } else if (this.activeName2 == '1') {
        //   let strtype = a ? '管理员业务' : '业务';
        //   this.getNum(strtype);
        // } else {
        //   this.getNum('');
        // }
        this.getNum(Number(this.activeName2));
      },
      handleClick() {
        // if (this.activeName == '1') {
        //   this.listQuery = {
        //     key: '',
        //     pageNum: 1,
        //     pageSize: 10
        //   }
        //   this.getOATodolist();
        // } else {
        //   this.listQuery = {
        //     key: '',
        //     pageNum: 1,
        //     pageSize: 10,
        //     scop: this.activeName, //"0我参与的. 1 我发起的" 
        //   }
        //   this.listQuery.scop = this.activeName;
        //   this.WFSearch();
        // }
        this.listQuery.type = this.activeName;
        this.getOATodolist();
      },
      searchHandle() {
        this.getOATodolist();
      },
      getOAHomeInit() {
        let d = {
          key: '',
          type: '1',
          pageNum: 1,
          pageSize: 10,
        }
        xz.getOATodolist(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.Todolist_EmpWorks = res.data.totalcount;
          } else {
            this.Todolist_EmpWorks = 0;
          }
        })
      },
      //取待办列表
      getOATodolist() {
        this.loading = true;
        xz.getOATodolist(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.remainData = res.data.listRet;
            this.totalcount = res.data.totalcount;
            this.loading = false;
          } else {
            this.remainData = [];
            this.totalcount = 0;
            this.loading = false;
          }
        })
      },
      toHandel(item) {
        // if (item.WorkID) {
        //   this.$router.push({
        //     path: '/approveDtl',
        //     query: {
        //       WorkID: item.WorkID
        //     }
        //   })
        // }else{
        // this.$router.push({
        //   path: item.WebUrl
        // })
        this.needLoading = true;
        if (item.WebUrl.indexOf('tePaymentDtl') > -1) {
          if (item.FK_Flow == '1') {
            item.WebUrl = item.WebUrl + '&type=dtl&activeName=核销记录&from=staging'
          } else {
            item.WebUrl = item.WebUrl + '&type=approve&activeName=财务核销&from=staging'
          }
        }
        window.open(item.WebUrl, "_blank");
        // }

      },
      currentChange() {
        this.getOATodolist();
      },
      //已审批/我发起的
      WFSearch() {
        this.loading = true;
        xz.WFSearch(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.remainData = res.data.listRet;
            this.totalcount = 0;
            this.loading = false;
          } else {
            this.remainData = [];
            this.totalcount = 0;
            this.loading = false;
          }
        })
      },
      //获取招聘数据
      getNum(Type) {
        let info = {
          beempcont: 0,
          entrymouthcont: 0,
          interttodaycont: 0,
          interttorrcont: 0,
          pendingcont: 0,
          quitcont: 0,
          facetodaycont: 0,
          entrycont: 0,
          beworkcont: 0,
          quitmouthcont: 0,
          entryweekcont: 0,
          quitweekcont: 0
        }
        this.numList = info;
        this.workLoading = true;
        let str = `Workbench/GetPersonnelChangesData?UserId=${Cookies.get("userid-b")}&Type=${Type}`
        xz.rcGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.numList = res.data;
            this.workLoading = false;
          } else {
            this.numList = info;
            this.workLoading = false;
            this.$message.error('获取工作台数据出错')
          }
        })
      },
      toSignupList() {
        this.$router.push({
          path: '/signupList'
        })
      },
      goto(path) {
        this.$router.push({
          path: path
        })
      },
      gotoOut() {
        let id = Cookies.get("userid-b");
        window.open("https://large.joball.net/#/HomeView?isEmp=" + id, "_blank");
      },
      gotoOut2() {
        window.open("http://183.6.70.7:21789/JobCRM/");
      },
      getShortcutList() {
        this.shortcutList = [];
        let activeRouter = JSON.parse(localStorage.router);
        activeRouter.forEach(element => {
          if (element.powername == '雇员') {
            let data = {
              name: '招聘管理',
              path: '/signupList'
            }
            this.shortcutList.push(data)
            let data2 = {
              name: '商保增减员',
              path: '/declare'
            }
            this.shortcutList.push(data2)
            let data3 = {
              name: '电子签约',
              path: '/eleSigning'
            }
            this.shortcutList.push(data3)
          }
          if (element.powername == '薪酬') {
            let data = {
              name: '发薪',
              path: '/calcSalary'
            }
            this.shortcutList.push(data)
          }
          if (element.powername == '报表') {
            element.children.forEach(e => {
              if (e.powername == '利润报表') {
                let data = {
                  name: '利润表',
                  path: '/basicReport'
                }
                this.shortcutList.push(data)
              }
            });

          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
    padding-top: 10px;
  }

  .stagingBox {
    width: 600px;
    margin-right: 20px;
    border: 1px solid #c1c1c1;
    padding: 10px 20px;
  }

  .shortcuts {
    // width: 25%;
    width: 360px;
    padding: 10px 20px;
    border: 1px solid #c1c1c1;
  }

  .tabbox {
    width: 100%;
    justify-content: space-between;
    margin-bottom: 15px;
  }

  .approveItem {
    margin-bottom: 20px;
  }

  .approveTitle {
    padding: 3px 10px;
    border-radius: 8px;
    margin-right: 15px;
    color: #fff;
  }

  .warning {
    background-color: rgba(229, 115, 51, 1);
  }

  .success {
    background-color: #67C23A;
  }

  .dataBoard {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

  .dataItem {
    width: 33%;
    text-align: center;
    padding: 20px 0;
  }

  .dataNum {
    font-weight: 600;
    font-size: 24px;
  }

  .dataTitle {
    margin-top: 10px;
    font-size: 14px;
  }

  .messageTitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 30px;
  }

  .iconBox {
    font-size: 32px;
  }
</style>
<style>
  .page_staging .el-input--small .el-input__icon {
    line-height: 32px;
    height: 32px;
  }
</style>